import { computed, Signal } from "@angular/core";
import { StringUuid } from "../../domain/model/uuid/string-uuid";
import { StoreFeed } from "../../storage/data-store/model/master-data/store-feed";
import { StoreGroup } from "../../storage/data-store/model/master-data/store-group";
import { StorePen } from "../../storage/data-store/model/master-data/store-pen";
import { StoreAnimalWeighing } from "../../storage/data-store/model/registrations/store-animal-weighing";
import { AnimalWeighingViewModel } from "../animal-weighings/animal-weighing.viewmodel";
import { mapToFeedViewModel, mapToGroupViewModel, mapToPenViewModel } from "../../functions/data-store/data-store-to-viewmodels.function";
import { recordForEach, recordSet, getById } from "../../functions/record.function";

export const animalWeighingViewModelsConst = (
  awRegistrations: Signal<Record<string, StoreAnimalWeighing>>,
  pens: Signal<Record<string, StorePen>>,
  groups: Signal<Record<string, StoreGroup>>,
  feeds: Signal<Record<string, StoreFeed>>
) => {
  return computed(() => {
    const retRecord = {} as Record<string, AnimalWeighingViewModel>;

    recordForEach<StoreAnimalWeighing>(awRegistrations(), (aw) => {
      recordSet(
        retRecord,
        aw.id,
        new AnimalWeighingViewModel(
          new StringUuid(aw.id),
          new StringUuid(aw.batchWeighingId),
          aw.type,
          mapToPenViewModel(getById(pens, aw.penId)),
          mapToGroupViewModel(getById(groups, aw.groupId)),
          mapToFeedViewModel(getById(feeds, aw.feedId)),
           aw.updateInfo,
          aw.inputNumber,
          aw.inputWeight
        )
      );
    });

    return retRecord as Readonly<Record<string, AnimalWeighingViewModel>>;
  });
};
